<template>

    <div class="w-full">
        <div class="flex flex-wrap w-full font-bold bg-gray-300 rounded text-gray-800 shadow-md mb-6 mx-3">
			<div class="w-full py-3 px-4 md:w-auto -mb-3 md:mb-0">
				<router-link tag="button" to="/admin/sales/add" class="bg-green-600 text-white rounded px-2 py-1">
                    Add Sale
                </router-link>
			</div>
            
			<div class="flex-1 text-left py-3 px-4 w-full md:w-auto md:text-right">
				<router-link tag="button" to="/admin/sales/pending" class="bg-blue-700 text-white rounded px-2 py-1 md:ml-3 ml-0 mr-3 md:mr-0 mt-3 md:mt-0">
					Pending Sales
				</router-link>
				<router-link tag="button" to="/admin/sales/processing" class="bg-blue-700 text-white rounded px-2 py-1 md:ml-3 ml-0 mr-3 md:mr-0 mt-3 md:mt-0">
					Processing Sales
				</router-link>
				<!-- <router-link tag="button" to="/admin/sales/completed" class="bg-blue-700 text-white rounded px-2 py-1 md:ml-3 ml-0 mr-3 md:mr-0 mt-3 md:mt-0">
					Completed Sales
				</router-link> -->
                <router-link tag="button" to="/admin/sales/search" class="bg-blue-700 text-white rounded px-2 py-1 md:ml-3 ml-0 mr-3 md:mr-0 mt-3 md:mt-0">
					Sale Search
				</router-link>
			</div>
		</div>

        <Card class="w-full mb-6 mx-3">
            <template v-slot:header>
                Processing Sales
            </template>
            <template v-slot:body>
                <CustomTable>
                   <template v-slot:header>
                        <th class="bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"></th>
                        <th class="py-4 px-2 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Sale Details</th>
                        <th class="py-4 px-2 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Video</th>
                        <th class="py-4 px-2 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Invoice Number</th>
                        <th class="py-4 px-2 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Date</th>
                        <th class="py-4 px-2 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Amount</th>
                        <th class="py-4 px-2 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"></th>
                    </template>
                    <template v-slot:body>
                        <tr v-for="sale in sales">
                            <td class="py-4 pl-4 border-b border-grey-light">
                                <span class="w-2 h-2 rounded-full bg-blue-700 inline-block cursor-pointer" v-if="sale.method == 'cdn'" title="CDN" v-tippy></span>
                                <span class="w-2 h-2 rounded-full bg-green-700 inline-block cursor-pointer" v-if="sale.method == 'email'" title="Email" v-tippy></span>
                                <span class="w-2 h-2 rounded-full bg-black inline-block cursor-pointer" v-if="sale.method == 'manual'" title="Manual" v-tippy></span>
                            </td>
                            <td class="py-4 px-2 border-b border-grey-light text-center">
                                <strong>{{ sale.network.name }}</strong> <br/>
                                <small>({{ sale.purchaser.name }})</small> <br />
                                <i class="fa fa-exchange"></i> <br/>
                                {{ sale.owner.name }} <br />
                            </td>
                            <td class="py-4 px-2 border-b border-grey-light">{{ sale.video.title }}</td>
                            <td class="py-4 px-2 border-b border-grey-light">{{ sale.invoice_number }}</td>
                            <td class="py-4 px-2 border-b border-grey-light">{{ sale.created_at | displayLocalDateTime }}</td>
                            <td class="py-4 px-2 border-b border-grey-light">${{ sale.price }} / <span v-if="sale.stringer_cut !== null">${{ sale.stringer_cut }}</span><span v-if="sale.stringer_cut == null">N/A</span></td>
                            <td class="py-4 pl-2 pr-4 border-b border-grey-light text-right">
                                <button class="bg-green-600 px-2 py-1 text-white text-sm rounded ml-2" v-if="sale.status == 'occurring'" v-on:click="finalizeSale(sale)">
                                    Finalize
                                </button>
                                <button class="bg-blue-700 px-2 py-1 text-white text-sm rounded ml-2" v-if="sale.status == 'pending'" v-on:click="viewApproveSaleModal(sale)">
                                    Approve
                                </button>
                            </td>
                        </tr>
                        <tr class="text-center" v-if="sales.length == 0">
                            <td colspan="7" class="text-center">There are currently no processing sales.</td>
                        </tr>
                        <infinite-loading @infinite="infiniteHandler" style="opacity: 0; height: 0;">
                            <span slot="no-more"></span>
                        </infinite-loading>
                    </template>
                </CustomTable>
            </template>
        </Card>
    </div>
			
</template>

<script>

    import { EventBus } from '@/utils/events';
    import * as Config from '@/config'
    import { mapState, mapGetters } from 'vuex';
    import moment from 'moment';

    import InfiniteLoading from 'vue-infinite-loading';
    import CustomTable from '@/components/general/CustomTable'
    import Card from '@/components/partials/Card'

	export default {
		name: 'HelloWorld',
		data () {
			return {
                sales: [],
                options: this.getAuthorizationHeader(),
                resource_url: Config.apiPath + "/api/v2/admin/sales?status=occurring",
                current_page: 1,
                last_page: null,
                continueLoading: true,
			}
        },
        components: {
            InfiniteLoading,
            CustomTable,
            Card
		},
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
            ]),
            getProcessingSales() {
                var _this = this;
                this.$http.get(Config.apiPath + "/api/v2/admin/sales?status=occurring", this.getAuthorizationHeader()).then((response) => {
                    _this.sales = response.data
                });
            },
            finalizeSale(sale) {
                var _this = this;
                this.$swal({
                    title: 'Finalize sale?',
                    text: "Finalizing this sale will mark this sale as complete, and notify the user that payment is on it's way.",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, finalize sale!'
                }).then((result) => {
                    if (result.value) {

                        var data = {
                            id: sale.id,
                        }

                        // send mail
                        _this.$http.post(Config.apiPath + "/api/v2/admin/sales/finalize", data, _this.getAuthorizationHeader()).then((response) => {
                            

                            _this.$swal(
                                'Complete!',
                                'The sale has been marked as complete.',
                                'success'
                            )

                            sale.status = 'complete';


                        });
                    }

                })
            },
            refresh() {
                console.log(this.$refs.vpaginator)
                this.$refs.vpaginator.fetchData(this.resource_url + "&page=" + this.$refs.vpaginator.current_page)
            },

            infiniteHandler($state) {

                var _this = this;

                this.$http.get(this.resource_url + "&page=" + (this.current_page), this.getAuthorizationHeader()).then((response) => {
                    _this.current_page = response.data.current_page + 1;
                    _this.last_page = response.data.last_page;

                    if(response.data.current_page == response.data.last_page) {
                        _this.continueLoading = false;
                    }

                    var data = response.data.data;

                    const temp = [];
                    for (var i = 0; i < data.length; i++) {
                        temp.push(data[i]);
                    }
                    _this.sales = _this.sales.concat(temp);

                    $state.loaded();
                });

            },
        },
        filters: {
            displayMethod: function(data) {
                if(data == 'email') {
                    return "Email"
                } else if(data == 'cdn') {
                    return "CDN"
                } else if(data == 'manual') {
                    return "Manual"
                }
            },
            displayLocalDateTime: function(data) {
                return moment.utc(data).local().format('MM/DD/YY h:mm a');
            }
        }
	}
</script>

<style scoped>

</style>
